import React from 'react';
import styled from 'styled-components';
import { useMediaQuery, Tooltip } from '@material-ui/core';
import Ratio from 'react-ratio';
import { isMobile } from 'react-device-detect';
import images from '../assets';
import ScaleLoader from 'react-spinners/ScaleLoader';
import {  Modal, Fade } from '@material-ui/core';

export const MediaQuery = ({ children, min = null, max = null }) => {
  // const matches = useMediaQuery(min != null ? `(min-width:${min}px)` : `(max-width:${max}px)`);
  const matches = useMediaQuery(
    min != null && max != null
      ? `(min-width:${min}px) and (max-width:${max}px)`
      : min != null
      ? `(min-width:${min}px)`
      : `(max-width:${max}px)`
  );
  return matches ? children : null;
};


export const ContentsArea = ({ children, creditPage = false, style, ...props }) => {
  return (
    <>
      <MediaQuery min={1400}>
        <div {...props} style={{ width: 1400, ...style }}>
          {children}
        </div>
      </MediaQuery>
      <MediaQuery max={1399}>

        {creditPage ?
          <div {...props} style={{ width: 'calc(100% - 4px)', marginLeft: 2, marginRight: 2, ...style }}>
            {children}
          </div>
          :
          <div {...props} style={{ width: 'calc(100% - 30px)', marginLeft: 15, marginRight: 15, ...style }}>
            {children}
          </div>

        }
      </MediaQuery>
    </>
  );
};

export const ContentsWrap = ({ children,creditPage=false, style }) => {
  return (
    <RowColum style={style}>
      <ContentsArea creditPage={creditPage}>{children}</ContentsArea>
    </RowColum>
  );
};

export const LoadingModal = ({ show }) => {
  return (
    <Modal style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', zIndex: 9999 }} open={show}>
      <Fade in={show}>
        <div>
          <ScaleLoader color={'#fc8a06'} loading={true} size={300} />
        </div>
      </Fade>
    </Modal>
  );
};

export const VerticalSp = ({ sp, style }) => {
  return <div style={{ height: sp, ...style }} />;
};

export const VSLine = ({ height = 14, width = 1, bgcolor = '#aaaaaa' }) => {
  return <div style={{ backgroundColor: bgcolor, width, height }} />;
};

export const HSLine = ({ bgcolor = '#aaaaaa', height = 1, style }) => {
  return <div style={{ backgroundColor: bgcolor, width: '100%', height: height, ...style }} />;
};

export const HorizontalSp = ({ sp, style }) => {
  return <div style={{ width: sp, ...style }} />;
};

export const RowColum = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const RowCenter = styled.div`
  display: flex;
  align-items: center;
`;

export const Row = styled.div`
  display: flex;
  width: 100%;
`;

const DividerDiv = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;
export const Vdivider = ({ height = 15, ...props }) => {
  return (
    <DividerDiv {...props}>
      <img alt="" src={images.divider_v} style={{ height }} />
    </DividerDiv>
  );
};

const WrapStart = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: start;
`;

export const WrapAuto = ({ children, ...props }) => {
  return <WrapStart {...props}>{children}</WrapStart>;
};

export const NorPagenationItem = styled.div`
  width: 30px;
  height: 30px;
  cursor: pointer;
  font-family: 'NSCJKrR';
  font-size: 14px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0px 10px;
  color: #999999;
`;

export const ActPagenationItem = styled.div`
  width: 30px;
  height: 30px;
  cursor: pointer;
  font-family: 'NSCJKrR';
  font-size: 14px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0px 10px;
  background-color: #ff8a06;
  color: white;
`;

export const PagenationPrev = styled.div`
  width: 30px;
  height: 30px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0px 10px;
`;

export const PagenationFirst = styled.div`
  width: 30px;
  height: 30px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const ModalNorBtnT = styled.div`
  height: 45px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-family: 'NSCJKrB';
  cursor: pointer;
  border-radius: 5px;
  font-size: 18px;
  padding: 0px 40px;
  color: white;
`;
const ModalNorV2BtnT = styled.div`
  height: 45px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-family: 'NSCJKrB';
  cursor: pointer;
  border-style:solid;
  border-radius: 5px;
  border-width:thin;
  border-color: #ff8a06;
  font-size: 18px;
  padding: 0px 40px;
  background-color : #ffffff;
  color: #ff8a06;

  &:hover{
    background-color : #ff8a06;
    color: #ffffff;
  }

  

  
`;

export const TipBox = ({ title, intro, width, height, x, y, minW }) => {
  return (
    <div style={{
      display:'flex',
      position: 'absolute',
      top: x,
      left: y,
      opacity: 1,
      flexDirection:"column",
      minWidth: minW,
      borderRadius: 5, 
      width: width, 
      height: height, 
      alignItems: 'center',
      justifyContent: 'center',
      backgroundColor: 'rgb(241, 241, 241)',
      boxShadow: 'rgb(232, 232, 232) -2px 2px 2px 2px',
      padding: '4px 8px',
      }}>
        <div
          style={{color: '#FF8A06', fontSize: 12}}
        >{title}</div>
        <div
          style={{fontSize: 12}}
        >{intro}</div>
    </div>
  )
}

export const ModalNorBtn = ({ children,paymethod=false, style, onClick }) => {
  return paymethod?( 
  isMobile ? (
  
    <ModalNorV2BtnT style={{ padding: '0px 10px', ...style }} onClick={onClick}>
      {children}
    </ModalNorV2BtnT>
  ) : (
    <ModalNorV2BtnT style={style} onClick={onClick}>
      {children}
    </ModalNorV2BtnT>
  )
  )
  :
  (
    isMobile ? (
      <ModalNorBtnT style={{ padding: '0px 10px', width: 80, ...style }} onClick={onClick}>
        {children}
      </ModalNorBtnT>
    ) : (
      <ModalNorBtnT style={style} onClick={onClick}>
        {children}
      </ModalNorBtnT>
    )
  )
};

export const ModalContents = ({ children, style, onClose }) => {
  return (
    <>
      <div style={{ backgroundColor: 'white', borderRadius: 5, position: 'relative', ...style }} id="receipt">
        <MediaQuery min={500}>
          <div style={{ margin: 35 }}>{children}</div>
          <div onClick={onClose} style={{ position: 'absolute', top: 20, right: 20, cursor: 'pointer' }}>
            <img alt="" src={images.icon_close} />
          </div>
        </MediaQuery>
        <MediaQuery max={499}>
          <div style={{ margin: 15 }}>{children}</div>
          <div onClick={onClose} style={{ position: 'absolute', top: 20, right: 20, cursor: 'pointer' }}>
            <img alt="" src={images.icon_close} />
          </div>
        </MediaQuery>
      </div>
    </>
  );
};

export const ModalTitle = ({ children, style }) => {
  return (
    <>
      <VerticalSp sp={10} />
      <div style={{ fontFamily: 'NSCJKrM', fontSize: 20, color: 'black', lineHeight: '20px', ...style }}>{children}</div>
      <VerticalSp sp={20} />
    </>
  );
};

export const PageTitle = ({ children, style }) => {
  return (
    <>
      <MediaQuery min={900}>
        <div
          style={{
            fontFamily: 'NSCJKrB',
            fontSize: 42,
            color: 'black',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            textAlign: 'center',
            wordBreak: 'keep-all',
            ...style,
          }}
        >
          {children}
        </div>
      </MediaQuery>
      <MediaQuery max={899}>
        <MediaQuery min={700}>
          <div
            style={{
              fontFamily: 'NSCJKrB',
              fontSize: 32,
              color: 'black',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              textAlign: 'center',
              wordBreak: 'keep-all',
              ...style,
            }}
          >
            {children}
          </div>
        </MediaQuery>
        <MediaQuery max={699}>
          <div
            style={{
              fontFamily: 'NSCJKrB',
              fontSize: 26,
              color: 'black',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              textAlign: 'center',
              wordBreak: 'keep-all',
              ...style,
            }}
          >
            {children}
          </div>
        </MediaQuery>
      </MediaQuery>
    </>
  );
};

export const AlermPopArea = ({ children }) => {
  return isMobile ? (
    <div style={{ position: 'fixed', left: 15, top: 70, zIndex: 9999 }}>
      <div
        style={{ width: 'calc(100vw - 30px)', height: 'auto', borderRadius: 10, backgroundColor: 'white', border: '1px solid #dddddd' }}
      >
        <VerticalSp sp={15} />
        <div style={{ display: 'flex' }}>
          <HorizontalSp sp={15} />
          <div style={{ flex: 1 }}>{children}</div>
          <HorizontalSp sp={15} />
        </div>
        <VerticalSp sp={15} />
      </div>
    </div>
  ) : (
    <>
      <MediaQuery min={1400}>
        <div style={{ position: 'fixed', left: 'calc(50vw - 700px)', top: 120, zIndex: 99 }}>
          <div
            style={{ width: 498, height: 'auto', borderRadius: 10, backgroundColor: 'white', border: '1px solid #dddddd' }}
          >
            <VerticalSp sp={19} />
            <div style={{ display: 'flex' }}>
              <HorizontalSp sp={19} />
              <div style={{ flex: 1 }}>{children}</div>
              <HorizontalSp sp={19} />
            </div>
            <VerticalSp sp={19} />
          </div>
        </div>
      </MediaQuery>
      <MediaQuery max={1399}>
        <div style={{ position: 'fixed', left: 15, top: 80, zIndex: 99 }}>
          <div
            style={{ width: 498, height: 'auto', borderRadius: 10, backgroundColor: 'white', border: '1px solid #dddddd' }}
          >
            <VerticalSp sp={19} />
            <div style={{ display: 'flex' }}>
              <HorizontalSp sp={19} />
              <div style={{ flex: 1 }}>{children}</div>
              <HorizontalSp sp={19} />
            </div>
            <VerticalSp sp={19} />
          </div>
        </div>
      </MediaQuery>
    </>
  );
};

export const NorButton = styled.button`
  background-color: #ff8a06;
  font-family: 'NSCJKrM';
  font-size: 14px;
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  width: 140px;
  height: 30px;
  border: none;
`;

export const PswToolTip = ({ title, children, ...otherprops }) => {
  return (
    <Tooltip
      TransitionProps={{ style: { backgroundColor: '#ff8a06', margin: 0, marginBottom: 5, maxWidth: 'none', padding: '5px 8px' } }}
      title={
        <div style={{ fontFamily: 'NSCJKrR', color: 'white', fontSize: 12, lineHeight: '12px', position: 'relative' }}>
          {title}
          <div
            style={{
              position: 'absolute',
              bottom: 0,
              width: '100%',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
            }}
          >
            {isMobile && <img alt="" src={images.tooltip_arrow} style={{ position: 'relative', top: 13 }} />}
            {!isMobile && <img alt="" src={images.tooltip_arrow} style={{ position: 'relative', top: 9 }} />}
          </div>
        </div>
      }
      placement="top"
      {...otherprops}
    >
      {children}
    </Tooltip>
  );
};

export const CheckBox = ({ key, id, isCheck, checkItemHandeler, style }) => {
  return (
    <label>
      <input
        id={id}
        type="checkbox"
        checked={isCheck}
        onChange={(e) => checkItemHandeler(e)}
        style={{ cursor: 'pointer', zoom: 1.3, ...style }}
      />
    </label>
  )
}
